/* eslint-disable no-return-assign */
/* eslint-disable prefer-promise-reject-errors */

export function cancellablePromise(promise) {
  let isCanceled = false;

  const wrappedPromise = new Promise((resolve, reject) => {
    promise.then(
      (value) => (isCanceled ? reject({isCanceled, value}) : resolve(value)),
      (error) => reject({isCanceled, error}),
    );
  });

  return {
    promise: wrappedPromise,
    cancel: () => (isCanceled = true),
  };
}

export function delay(n) {
  // eslint-disable-next-line no-promise-executor-return
  return new Promise((resolve) => setTimeout(resolve, n));
}
